import React from 'react';
import { connect } from 'react-redux';

import BillingActions from 'app/shared/actions/BillingActions';

import BillingSelectors from 'app/shared/selectors/BillingSelectors';
import UserSelectors from 'app/shared/selectors/UserSelectors';

import LoadingConstants from 'app/shared/constants/LoadingConstants';
import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import { BillingAddPaymentModalContainer, StyledSpinnerContainer } from './StyledComponents';

let PaymentMethodIframeProviderWrapper;

const BillingAddPaymentModal = ({
    dispatch,
    user,
    accountNumber,
    paymentSessionInfo,
    paymentSessionInfoLoadingState,
    onCreditCardAdded,
}) => {
    const [isClient, setIsClient] = React.useState(false);
    const [iframeRendered, setIframeRendered] = React.useState(false);
    const iframeRef = React.useRef(null);
    const timer = React.useRef(null);
    const [customFields, setCustomFields] = React.useState(null);
    const [metroidAccountId, setMetroidAccountId] = React.useState(null);
    const [sessionToken, setSessionToken] = React.useState(null);

    const pollForIframe = () => {
        timer.current = setTimeout(() => {
            if (iframeRef.current.clientHeight > 0) {
                setIframeRendered(true);
            }
            pollForIframe();
        }, 200);
    };

    React.useEffect(() => {
        dispatch(BillingActions.getPaymentMethodSessionForAccount(accountNumber));
        if (__CLIENT__) {
            setIsClient(__CLIENT__);
            PaymentMethodIframeProviderWrapper = require('@zillow/metroid-payment-method').default;
        }
        pollForIframe();
        return () => clearTimeout(timer.current);
    }, []);

    React.useEffect(() => {
        setMetroidAccountId({
            brand: paymentSessionInfo.brand,
            businessUnit: paymentSessionInfo.businessUnit,
            userId: paymentSessionInfo.userId,
        });
        setSessionToken({
            referenceKey: paymentSessionInfo.referenceKey,
            secret: paymentSessionInfo.secret,
        });

        setCustomFields({
            ExternalUserId__c: user.userToken,
        });
    }, [paymentSessionInfo]);

    const handleSubmitFail = () => {
        // todo display message
    };

    if (isClient) {
        const showIframe = paymentSessionInfoLoadingState === LoadingConstants.SUCCESS
            && metroidAccountId && metroidAccountId && sessionToken;

        const showSpinner = paymentSessionInfoLoadingState === LoadingConstants.LOADING || !iframeRendered
            || paymentSessionInfoLoadingState === LoadingConstants.INITIAL || !iframeRendered;

        return (
            <BillingAddPaymentModalContainer>
                {showSpinner && (
                    <StyledSpinnerContainer>
                        <SpinnerContainer />
                    </StyledSpinnerContainer>
                )}
                <div ref={iframeRef} style={{ display: iframeRendered ? 'block' : 'hidden' }}>
                    {showIframe && (
                        <PaymentMethodIframeProviderWrapper
                            className="my-credit-card"
                            onSubmitSuccess={onCreditCardAdded}
                            onSubmitFailure={handleSubmitFail}
                            sessionToken={sessionToken}
                            metroidAccountId={metroidAccountId}
                            metroidConfigUrl={paymentSessionInfo.metroidConfigUrl}
                            metroidHPPConfigId="CC:Zillow:Zillow Rental Network"
                            endpointVersion="v1"
                            testConfigurations={{}}
                            setAsDefault={false}
                            customFields={customFields}
                            onRenderComplete={() => { }}
                        />
                    )}
                </div>
                {paymentSessionInfoLoadingState === LoadingConstants.ERROR && (
                    <div>
                        {ErrorMessageConstants.DEFAULT_ERROR}
                    </div>
                )}
            </BillingAddPaymentModalContainer>
        );
    }

    return null;
};

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    paymentSessionInfo: BillingSelectors.makePaymentSessionInfo(state),
    paymentSessionInfoLoadingState: BillingSelectors.makePaymentSessionInfoLoadingState(state),
});

export { BillingAddPaymentModal };
export default connect(mapStateToProps)(BillingAddPaymentModal);
